import {PlusIcon} from '@logistics-frontend/blocks'
import {IconButton} from '@logistics-frontend/blocks/legacy'
import {useMapContext, ZOOM_ANIMATION} from '@yandex-taxi/react-ymaps'
import clsx from 'clsx'
import React, {useCallback} from 'react'

import {useClasses} from './classes'

const ZOOM_STEP = 1

const ZoomControl: React.FC = () => {
  const classes = useClasses()
  const map = useMapContext()

  const increaseZoom = useCallback(() => {
    map.setZoom(map.getZoom() + ZOOM_STEP, ZOOM_ANIMATION)
  }, [map])

  const decreaseZoom = useCallback(() => {
    map.setZoom(map.getZoom() - ZOOM_STEP, ZOOM_ANIMATION)
  }, [map])

  return (
    <>
      <IconButton aria-label="+" className={clsx(classes.button, classes.topButton)} onClick={increaseZoom}>
        <PlusIcon className={classes.icon} />
      </IconButton>
      <IconButton aria-label="-" className={clsx(classes.button, classes.bottomButton)} onClick={decreaseZoom}>
        &ndash;
      </IconButton>
    </>
  )
}

export default ZoomControl
